import type { ReportAnswers } from '../../../../report/CustomerReport';
import { isAnswerValueSelected } from '../../../../report/getQuestion';
import { OverheadWireIssueQuestionValue } from '../../../../report/questions/problemType/equipment/overheadWire/WireIssueQuestion';
import { WireTypeQuestionValue } from '../../../../report/questions/problemType/equipment/overheadWire/WireTypeQuestion';
import { ReportQuestion } from '../../../../report/questions/ReportQuestion';
import { StandardObject } from '../../../interfaces/api/CustomerReport';
import { isPoliceFire } from './isPoliceFire';

export function isWireDownOrWithinReachV3(answers: ReportAnswers | undefined): boolean | undefined {
	const wireDown = isAnswerValueSelected(answers, ReportQuestion.OverheadWireIssue, [
		OverheadWireIssueQuestionValue.Down,
		OverheadWireIssueQuestionValue.WithinReach,
	]);
	if (wireDown) {
		return true;
	}

	const trappedByWire = isAnswerValueSelected(answers, ReportQuestion.PublicTrappedBy, StandardObject.PowerLine);
	if (trappedByWire) {
		return true;
	}

	if (wireDown === false || trappedByWire === false) {
		return false;
	}

	return undefined;
}

export function isPoleToBuildingDown(answers: ReportAnswers): boolean {
	// Not a pole to pole wire
	const poleToBuilding = isAnswerValueSelected(
		answers,
		ReportQuestion.WireType,
		WireTypeQuestionValue.PoleToBuilding,
	);
	if (!poleToBuilding) {
		return false;
	}

	const policeFire = isPoliceFire(answers);
	if (policeFire) {
		return true;
	}

	// Wire is down or within reach
	const wireDown = isWireDownOrWithinReachV3(answers);
	if (!wireDown) {
		return false;
	}

	return true;
}

export function isPoleToBuildingDownPF(answers: ReportAnswers): boolean {
	// Not a pole to pole wire
	const poleToBuilding = isAnswerValueSelected(
		answers,
		ReportQuestion.WireType,
		WireTypeQuestionValue.PoleToBuilding,
	);
	if (!poleToBuilding) {
		return false;
	}

	return true;
}
